<div class="font-bold py-2 text-3xl">Applications</div>
<div class="flex flex-row flex-wrap gap-4 justify-start">
  <!--Search-->
  <p-card class="nav-card interactive-card">
    <div class="flex flex-row flex-nowrap w-full">
      <div class="flex-initial flex items-center justify-center pr-6">
        <img src="../../assets/images/search-navy.png" class="basic-icon max-w-16">
        <img src="../../assets/images/search-color.png" class="alt-icon max-w-16">
      </div>
      <div class="items-center justify-center py-2 text-blue-950">
        <div class="text-xl font-bold p-1 ">Search</div>
        <div class="p-1 max-w-44 text-base overflow-auto">Find studies using metadata keywords</div><br />
        <button pButton type="button" routerLink="/search">Launch</button>
      </div>
    </div>
  </p-card>

  <!--Data Packages-->
  <p-card class="nav-card interactive-card">
    <div class="flex flex-row flex-nowrap w-full">
      <div class="flex-initial flex items-center justify-center pr-6">
        <img src="../../assets/images/user-navy.png" class="basic-icon max-w-16">
        <img src="../../assets/images/user-color.png" class="alt-icon max-w-16">
      </div>
      <div class="items-center justify-center py-2">
        <div class="text-xl font-bold p-1 text-blue-950">Data Packages</div>
        <div class="p-1 max-w-44 text-base overflow-auto">View and download data packages</div><br />
        <button pButton type="button" routerLink="/data-packages">Launch</button>
      </div>
    </div>
  </p-card>

  <!--Curation-->
  <p-card class="nav-card interactive-card">
    <div class="flex flex-row flex-nowrap w-full">
      <div class="flex-initial flex items-center justify-center pr-6">
        <img src="../../assets/images/study-navy.png" class="basic-icon max-w-16">
        <img src="../../assets/images/study-color.png" class="alt-icon max-w-16">
      </div>
      <div class="items-center justify-center py-2">
        <div class="text-xl font-bold p-1 text-blue-950">Study Curation</div>
        <div class="p-1 max-w-44 text-base overflow-auto">Submit a study through the intake form</div><br />
        <button pButton type="button" routerLink="/curation">Launch</button>
      </div>
    </div>
  </p-card>

  <!--Files -->
  <p-card class="nav-card interactive-card">
    <div class="flex flex-row flex-nowrap w-full">
      <div class="flex-initial flex items-center justify-center pr-6">
        <img src="../../assets/images/files-navy.png" class="basic-icon max-w-16">
        <img src="../../assets/images/files-color.png" class="alt-icon max-w-16">
      </div>
      <div class="items-center justify-center py-2">
        <div class="text-xl font-bold p-1 text-blue-950">File Upload</div>
        <div class="p-1 max-w-44 text-base overflow-auto">Upload files, where they can be added to assays</div><br />
        <button pButton type="button" routerLink="/files">Launch</button>
      </div>
    </div>
  </p-card>

  <!--File Types-->
  <p-card class="nav-card interactive-card">
    <div class="flex flex-row flex-nowrap w-full">
      <div class="flex-initial flex items-center justify-center pr-6">
        <img src="../../assets/images/annotation-navy.png" class="basic-icon max-w-16">
        <img src="../../assets/images/annotation-color.png" class="alt-icon max-w-16">
      </div>
      <div class="items-center justify-center py-2">
        <div class="text-xl font-bold p-1 text-blue-950">File Types</div>
        <div class="p-1 max-w-44 text-base overflow-auto">View and administer data file definitions</div><br />
        <button pButton type="button" routerLink="/file-type">Launch</button>
      </div>
    </div>
  </p-card>


  <!--Metadata-->
  @if (userIsCurator) {
  <p-card class="nav-card interactive-card">
    <div class="flex flex-row flex-nowrap w-full">
      <div class="flex-initial flex items-center justify-center pr-6">
        <img src="../../assets/images/admin-navy.png" class="basic-icon max-w-16">
        <img src="../../assets/images/admin-color.png" class="alt-icon max-w-16">
      </div>
      <div class="items-center justify-center py-2">
        <div class="text-xl font-bold p-1 text-blue-950">Metadata</div>
        <div class="p-1 max-w-44 text-base overflow-auto">Access administrative controls</div><br />
        <button pButton type="button" routerLink="/admin">Launch</button>
      </div>
    </div>
  </p-card>
  }

  <!--Protocols-->
  @if (userIsCurator) {
  <p-card class="nav-card interactive-card">
    <div class="flex flex-row flex-nowrap w-full">
      <div class="flex-initial flex items-center justify-center pr-6">
        <img src="../../assets/images/protocol-navy.png" class="basic-icon max-w-16">
        <img src="../../assets/images/protocol-color.png" class="alt-icon max-w-16">
      </div>
      <div class="items-center justify-center py-2">
        <div class="text-xl font-bold p-1 text-blue-950">Protocols</div>
        <div class="p-1 max-w-44 text-base overflow-auto">View and administer protocols</div><br />
        <button pButton type="button" routerLink="/protocols">Launch</button>
      </div>
    </div>
  </p-card>
  }
</div>